export const i18n = (i18n: Record<string, string | string[]>, key: string) => {
    const value = i18n[key]

    if (typeof value === "string") {
        return value
    }

    return ""
}

export const i18ns = (i18n: Record<string, string | string[]>, key: string) => {
    const value = i18n[key]

    if (Array.isArray(value)) {
        return value
    }

    return []
}

export function parseColorString(input: string) {
    const regex = /<color>(.*?)<\/color>/g
    let match
    let startPos = 0
    const result: {
        text: string
        color: boolean
    }[] = []

    while ((match = regex.exec(input)) !== null) {
        const pos = match.index
        const text = input.substring(startPos, pos)
        const currentResult = {
            text,
            color: false,
        }
        startPos = pos + match[0].length
        result.push(currentResult)
        const colorText = match[1]
        if (colorText) {
            result.push({
                text: colorText,
                color: true,
            })
        }
    }

    const lastPart = input.substring(startPos, input.length)
    if (lastPart) {
        result.push({
            text: lastPart,
            color: false,
        })
    }

    return result
}

export const i18nColor = (
    i18n: Record<string, string | string[]>,
    key: string
) => {
    const value = i18n[key]

    if (typeof value === "string") {
        return parseColorString(value)
    }

    return []
}
